export var EIntervalType;
(function (EIntervalType) {
    EIntervalType["Yearly"] = "Yearly";
    EIntervalType["Monthly"] = "Monthly";
    EIntervalType["Quarterly"] = "quarterly";
})(EIntervalType || (EIntervalType = {}));
